module.exports = __webpack_public_path__ + "img/circle-right.39de038f.svg";